export default {
    styleOverrides: {
        root: ({ theme }) => ({
            color: theme.vars.palette.primary.main,
        }),
    },
};
